export const CLIENT_TYPE = {
  PERSON: "Person",
  COMPANY: "Company",
};

export const SINGLE_CLIENT_REPORT_ENTRIES_LOG_MESSAGES = {
  NOT_FOUND: "No records were found",
};

export const FILTERS_LABELS_SINGLE_CLIENT_REPORT = {
  type: "Type",
  firstName: "First name",
  middleName: " Middle name",
  lastName: "Last name",
  fullName: "Full Name",
  clientNumber: "EGN / Company number",
  clientOfferId: "Client offer Id",
};

export const INITIAL_FILTERS_SINGLE_CLIENT_REPORT = {
  type: "",
  firstName: "",
  middleName: "",
  lastName: "",
  fullName: "",
  clientNumber: "",
  clientOfferId: "",
  customClientParameters: [],
}



// WEBPACK FOOTER //
// ./src/features/reports/constants/singleClientEntriesReportConstants.js